<script setup>
  import {ref} from "vue";

  import ComponentDoctorIcon from "@components/Icons/CustomIcons/DoctorIcon.vue";
  import ComponentFrontDeskIcon from "@components/Icons/CustomIcons/FrontDeskIcon.vue";
  import ComponentLaptopIcon from "@components/Icons/CustomIcons/LaptopIcon.vue";
  import ComponentOptionsOnMobileIcon from "@components/Icons/CustomIcons/OptionsOnMobileIcon.vue";
  import ComponentPatientIcon from "@components/Icons/CustomIcons/PatientIcon.vue";
  import ComponentScanQrCodeIcon from "@components/Icons/CustomIcons/ScanQrCodeIcon.vue";
  import ComponentSignOnMobileIcon from "@components/Icons/CustomIcons/SignOnMobileIcon.vue";

  defineOptions({
    name: "ComponentIcon",
  });

  const props = defineProps({
    clickable: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: String,
      default: null,
    },
    smallCustomIcon: {
      type: Boolean,
      default: true,
    },
  });

  defineEmits(["click"]);

  const customIcon = ref(props.custom);
</script>

<template>
  <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events, vuejs-accessibility/no-static-element-interactions -- presentational wrapper: the click is an unconditional passthrough, and most usages are decorative or already nested in a button; consumers that make the icon the control must provide the semantics themselves -->
  <div
    v-if="customIcon === null"
    class="p4umc-icon select-none"
    :class="{'cursor-pointer': clickable}"
    :data-test="getTestId('icon')"
    @click="$emit('click')"
  >
    <slot />
  </div>

  <ComponentPatientIcon
    v-else-if="customIcon === 'patient' || customIcon === 'custom:patient'"
    :class="{'size-4': smallCustomIcon, 'size-6': !smallCustomIcon, 'cursor-pointer': clickable}"
    :test-id="testId"
  />

  <ComponentDoctorIcon
    v-else-if="customIcon === 'doctor' || customIcon === 'custom:doctor'"
    :class="{'size-4': smallCustomIcon, 'size-6': !smallCustomIcon, 'cursor-pointer': clickable}"
    :test-id="testId"
  />

  <ComponentFrontDeskIcon
    v-else-if="customIcon === 'front-desk'"
    :class="{'cursor-pointer': clickable}"
    :test-id="testId"
  />

  <ComponentLaptopIcon v-else-if="customIcon === 'laptop'" :class="{'cursor-pointer': clickable}" :test-id="testId" />

  <ComponentScanQrCodeIcon
    v-else-if="customIcon === 'scan-qr-code'"
    :class="{'cursor-pointer': clickable}"
    :test-id="testId"
  />

  <ComponentOptionsOnMobileIcon
    v-else-if="customIcon === 'options-on-mobile'"
    :class="{'cursor-pointer': clickable}"
    :test-id="testId"
  />

  <ComponentSignOnMobileIcon
    v-else-if="customIcon === 'sign-on-mobile'"
    :class="{'cursor-pointer': clickable}"
    :test-id="testId"
  />
</template>
